import React, { useEffect, useState } from 'react';

import { supplierInventoryHistoryApi } from '@/main/api';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { SupplierInventoryGridHistoryResponse } from '@/main/models/response';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import * as S from './styles';

interface Props {
  open?: any;
  closeModal?: any;
  dataRowHistory: SupplierInventoryGridHistoryResponse | null;
}

function PartImport({ open, closeModal, dataRowHistory }: Props) {
  const [isLoadingInfo, setIsLoadingInfo] = useState(true);
  const [details, setDetails] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [parts, setParts] = useState([]);

  useEffect(() => {
    if (open && !isNullUndefined(dataRowHistory)) {
      setIsLoadingInfo(true);
      supplierInventoryHistoryApi
        .getImportDetail({
          guidSupplierInventoryHistory: String(dataRowHistory.guidSupplierInventoryHistory)
        })
        .then(response => {
          const resultData = response.data.result;
          setDetails(resultData.supplierInventoryHistoryDetail);
          setVehicles(resultData.vehicles);
          setParts(resultData.parts);
        })
        .catch(() => { })
        .finally(() => {
          setIsLoadingInfo(false);
        });
    }
  }, [dataRowHistory?.guidSupplierInventoryHistory]);

  if (isNullUndefined(dataRowHistory)) return null;

  const titleTypeHistory = dataRowHistory.description || getTranslateByKey('information.partimport')
  return (
    <>
      {open && (
        <KogModalSideComponent
          open={open}
          closeModal={() => closeModal()}
          title={getTranslateByKey('information.historyDetails')}
          id="id-partImport-modal-scroll">
          <S.AccordionContainer>
            <S.AccordionTitle>
              {titleTypeHistory}
            </S.AccordionTitle>
            {!isLoadingInfo &&
              !isNullUndefined(details) &&
              !isNullUndefined(parts) &&
              !isNullUndefined(vehicles) ? (
              <S.AccordionDetailsHistory>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'quoteCard.category'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partCategoryName}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'quoteCard.subCategory'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partSubCategoryName}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.xnuupPartId'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.xnuupId}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.position'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.position}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.sku'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.sku}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.name'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partTitle}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.type'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partType}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.partBrand'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partBrand}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.partNumberOem'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partNumberOEM}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.partNumberIAM'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partNumberIAM}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.amount'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.stock}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.dimensions'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.dimensions}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.weight'
                  )} (kg):`}</S.LabelItem>
                  <S.LabelResult>{details.weight}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'partdetail.packageContent'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.packageContent}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.warrantyPeriodDays'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.warranty}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.pickupTime'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.pickupTime}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'partdetail.color'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.color}</S.LabelResult>
                </S.ContainerLabel>
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.description'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.partDescription}</S.LabelResult>
                </S.ContainerLabel>
                {details.image1 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 1
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image1}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                {details.image2 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 2
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image2}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                {details.image3 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 3
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image3}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                {details.image4 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 4
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image4}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                {details.image5 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 5
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image5}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                {details.image6 && (
                  <S.ContainerLabel>
                    <S.LabelItem>{`${getTranslateByKey('quoteCard.image') + 6
                      }:`}</S.LabelItem>
                    <S.LabelResult>{details.image6}</S.LabelResult>
                  </S.ContainerLabel>
                )}
                <S.ContainerLabel>
                  <S.LabelItem>{`${getTranslateByKey(
                    'information.status'
                  )}:`}</S.LabelItem>
                  <S.LabelResult>{details.status}</S.LabelResult>
                </S.ContainerLabel>
                {vehicles.map(vehicle => (
                  <S.ContainerLabel key={vehicle.guidVehicle}>
                    <S.LabelItem>{`${getTranslateByKey(
                      'information.vehicle'
                    )}:`}</S.LabelItem>
                    <S.LabelResult>
                      {vehicle.manufacturer +
                        ' ' +
                        vehicle.model +
                        ' ' +
                        vehicle.submodel +
                        ' ' +
                        vehicle.year}
                    </S.LabelResult>
                  </S.ContainerLabel>
                ))}
                {parts.map(part => (
                  <>
                    {part.companyType && (
                      <S.ContainerLabel>
                        <S.LabelItem>{`${getTranslateByKey(
                          'information.companyType'
                        )}:`}</S.LabelItem>
                        <S.LabelResult>{part.companyType}</S.LabelResult>
                      </S.ContainerLabel>
                    )}
                    {part.companyType && (
                      <S.ContainerLabel>
                        <S.LabelItem>{`${getTranslateByKey(
                          'information.companyName'
                        )}:`}</S.LabelItem>
                        <S.LabelResult>{part.company}</S.LabelResult>
                      </S.ContainerLabel>
                    )}
                    <S.ContainerLabel>
                      <S.LabelItem>{`${getTranslateByKey(
                        'information.autoDeliveryPrice'
                      )}:`}</S.LabelItem>
                      <S.LabelResult>{part.autoDeliveryPriceWithCost}</S.LabelResult>
                    </S.ContainerLabel>
                    <S.ContainerLabel>
                      <S.LabelItem>{`${getTranslateByKey(
                        'information.shippingPrice'
                      )}:`}</S.LabelItem>
                      <S.LabelResult>{part.shippingPrice}</S.LabelResult>
                    </S.ContainerLabel>
                    <S.ContainerLabel>
                      <S.LabelItem>{`${getTranslateByKey(
                        'information.autoDeliverywithoutPrice'
                      )}:`}</S.LabelItem>
                      <S.LabelResult>{part.autoDeliveryPrice}</S.LabelResult>
                    </S.ContainerLabel>
                  </>
                ))}

              </S.AccordionDetailsHistory>
            ) : (
              <LoadingComponent />
            )}
          </S.AccordionContainer>
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: 10 }}>
            <SecondaryButton
              id="id-partImport-button-back"
              onClick={() => closeModal()}>
              {getTranslateByKey('information.back')}
            </SecondaryButton>
          </div>
        </KogModalSideComponent>
      )}
    </>
  );
}

export default PartImport;
